import { render, staticRenderFns } from "./CustomElementAdd.vue?vue&type=template&id=14a175e6&scoped=true&"
import script from "./CustomElementAdd.vue?vue&type=script&lang=js&"
export * from "./CustomElementAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a175e6",
  null
  
)

export default component.exports